import { ure_section_status } from '../constants/underwriting';

export const isEmptyObj = (obj) => {
  if (!obj) return true;
  return Object.keys(obj).length === 0;
};

export const isEmpty = (value) => {
  return value === null || value === '';
};

export const isEmptyArray = (value) => {
  try {
    if (Array.isArray(value) && value.length <= 0) {
      return true;
    }
    return false;
  } catch {
    return true;
  }
};

export const isQuestionTypeValid = (types, type) =>
  [...types].includes(type) ? true : false;

export const getMarkup = (html) => {
  return { __html: html };
};

export const getLastQuestion = (questions, questionIndex) => {
  return questions.length === questionIndex + 1 ? true : false;
};

export const toFixed = (num, fixed) => {
  const re = new RegExp(`^-?\\d+(?:.\\d{0,${fixed || -1}})?`);
  return num.toString().match(re)[0];
};

export const convertFeetToCms = (value) => value * 30.48;

export const convertInchesToCms = (value) => value * 2.54;

export const convertFeetToM = (value) => (value * 30.48) / 100;

export const convertInchesToM = (value) => (value * 2.54) / 100;

export const convertCmToFeet = (value) =>
  `${Math.floor(value / 30.48).toString()}.${Math.round(
    (value / 30.48 - Math.floor(value / 30.48)) * 12
  )}`;

export const convertCmToInches = (value) => value / 2.54;

export const convertMetresToInches = (value) => (100 * value) / 2.54;

export const convertInchesToFtnIn = (inches) => ({
  feet: Math.floor(inches / 12),
  inches: Math.floor(inches % 12),
});

export const convertMetresToCms = (value) => value * 100;

export const convertCmsToMetres = (value) => value / 100;

export const convertCmsToFtnIn = (cm) => {
  const length = convertCmToInches(cm);
  const feet = Math.floor(length / 12);
  const inches = Math.floor(length - 12 * feet);
  return { feet, inches };
};

export const convertMetresToFtnIn = (m) => {
  const length = convertMetresToInches(m) + 0.00000001;
  const feet = Math.floor(length / 12);
  const inches = Math.floor(length - 12 * feet);
  return { feet, inches };
};

export const convertFeetInchesToCms = (feet, inches) =>
  convertFeetToCms(feet) + convertInchesToCms(inches);

export const convertFeetInchesToMetres = (feet, inches) =>
  (convertFeetToCms(feet) + convertInchesToCms(inches)) / 100;

export const getSectionStatus = (section) => {
  if (section.isSatisfied) return ure_section_status.COMPLETE;

  try {
    if (
      !section.isSatisfied &&
      section.enquiryLines.filter(
        (enquiryLine) =>
          enquiryLine.questions.filter((question) => !!question.isSatisfied)
            .length > 0
      ).length > 0
    )
      return ure_section_status.IN_PROGRESS;
  } catch {
    return ure_section_status.NOT_STARTED;
  }
  return ure_section_status.NOT_STARTED;
};

export const convertStoneToKg = (value) =>
  (Math.floor(value) * 14 + parseInt(value.toString().split('.')[1] || 0, 10)) *
  0.4536;

export const convertKgToStonePounds = (value) => {
  const significant = Math.floor(value / 6.35029318);
  const fractal = Math.round(
    parseFloat(
      parseFloat(`0.${(value / 6.35029318).toString().split('.')[1] || 0}`) * 14
    )
  );
  if (fractal >= 10 && fractal <= 14) {
    return { stone: significant, pounds: fractal };
  }
  return {
    stone: significant,
    pounds: parseFloat(fractal.toString().substring(0, 1)),
  };
};

export const convertStonePoundsToKg = (stone, pounds) => {
  const lb = parseFloat(stone) * 14 + parseFloat(pounds);
  const kg = lb / 2.204623;
  return kg;
};

export const getCmToInches = (value) => ({
  inches: Math.floor(convertCmToInches(value)),
});

export const numericOnly = (value) =>
  !Number(value) && value.length > 0 ? false : true;

export const numericWholeOnly = (value) =>
  value === '' || (numericOnly(value) && value.match(/^-?\d+$/)) ? true : false;

export const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);
